import React from 'react';
import PropTypes from 'prop-types';

class IndividualTreatmentVisualisationBase extends React.Component {
	
	// onBaseSvgLoad = (event) => {
	// 	this.svgTreatment = event.target.contentDocument;
	// 	this.setAdjustedPowerOutput(this.props.AdjustedPowerOutput);
	// 	this.setPowerOutput(this.props.PowerOutput);
	// 	this.setChargeDelay(this.props.ChargeDelay);
	// }

	__set(elemName, value) {
		//console.log(`IndividualTreatmentVisualisationBase.__set(${elemName}, ${value})`)
		if ((undefined !== this.svgTreatment) && (null !== this.svgTreatment)) {
			var elem = this.svgTreatment.getElementById(elemName);
			elem.textContent = value;
		}
	}

	__setFill(elemName, value) {
		//console.log(`IndividualTreatmentVisualisationBase.__setFill(${elemName}, ${value})`)
		if ((undefined !== this.svgTreatment) && (null !== this.svgTreatment)) {
			var elem = this.svgTreatment.getElementById(elemName);
			elem.style.fill = value;
		}
	}
	
	setPowerOutput(value) {
		// console.log(`setPowerOutput value=${value}`)
		this.PowerOutput = value;
		var str = "";
		if (null !== value) {
			str = "(" + Number(value).toFixed(0) + "%)";
		}
		this.__set("textPowerOutput", str);
	}

	setAdjustedPowerOutput(value) {
		this.AdjustedPowerOutput = value;
		this.__set("textAdjustedPowerOutput", "" + Number(value).toFixed(0) + "%");
	}

	setPowerChangePendingHighlight(value) {
		// console.log(`IndividualTreatmentVisualisationBase.setPowerChangePendingHighlight(${value})`)
		this.__setFill('rectAdjustedPowerOutput', value);
		if (null !== this.PowerOutput) this.__setFill('rectPowerOutput', value);
	}

	setChargeDelay(value) {
		// console.log(`setChargeDelay value=${value}`)
		this.ChargeDelay = value;
		var str = "";
		if ((null !== value)) {
			str = "(" + Number(value).toFixed(0) + "ms)";
		}
		this.__set("textChargeDelay", str);
	}

}

IndividualTreatmentVisualisationBase.propTypes = {
    AdjustedPowerOutput: PropTypes.number,
    PowerOutput: PropTypes.number,
    ChargeDelay: PropTypes.number,
};

IndividualTreatmentVisualisationBase.defaultProps = {
    AdjustedPowerOutput: 120,
    PowerOutput: 84
};

export default IndividualTreatmentVisualisationBase;